import React, { useState, useEffect } from 'react';
import '../styles/Navbar.css';

const LINKS = [
  { key: 'home', label: 'Home' },
  { key: 'about', label: 'About' },
  { key: 'services', label: 'Services' },
  { key: 'blog', label: 'Blog' },
  { key: 'contact', label: 'Contact' },
];

const Navbar = ({ currentPage, onNavigate }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close menu on page change
  const handleNav = (page) => {
    onNavigate(page);
    setMenuOpen(false);
  };

  // Prevent body scroll when menu open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  return (
    <nav className={`navbar${scrolled ? ' scrolled' : ''}`}>
      {/* Logo */}
      <button className="navbar__logo" onClick={() => handleNav('home')}>

        <img
          src="/assets/pragyalogo.png"   // change to your logo path
          alt="Pragya HR Logo"
          className="navbar__logo-img"
        />

        <div className="navbar__logo-text">
          <span className="navbar__logo-main">Pragya </span>
          <span className="navbar__logo-sub">HR Solutions</span>
        </div>

      </button>

      {/* Nav links (desktop) + full-screen overlay (mobile) */}
      <ul className={`navbar__links${menuOpen ? ' open' : ''}`}>
        {LINKS.map(({ key, label }) => (
          <li key={key}>
            <button
              className={currentPage === key ? 'active' : ''}
              onClick={() => handleNav(key)}
            >
              {label}
            </button>
          </li>
        ))}

        {/* <li className="navbar__cta-wrap"><button className="navbar__cta button" onClick={() => handleNav('contact')}> Get Started</button></li> */}
      </ul>

      {/* <button className="navbar__cta button" onClick={() => handleNav('contact')}> Get Started </button> */}

      {/* Hamburger */}
      <button className={`navbar__hamburger${menuOpen ? ' open' : ''}`} onClick={() => setMenuOpen(p => !p)} aria-label="Toggle menu" aria-expanded={menuOpen}>
        <span />
        <span /><span />
      </button>
    </nav>
  );
};

export default Navbar;